<template>
  <q-page class="bg-white">
    <q-card class="my-card" flat>
      <q-img
        :src="configTemplate_mainBackground"
        placeholder-src="hero-results-compressed-small.jpg"
        no-spinner
        alt=""
        height="250px">
        <div class="hero fit col wrap justify-center items-center content-center text-blur">

        <q-skeleton v-if="documents === null" type="text" tag="div" style="width: 50%; height: 5vh" animation="fade"></q-skeleton>
        <div v-else class="text-h1 text-center text-primary font-title">{{ eventName }}</div>

        <q-skeleton v-if="documents === null" type="text" tag="div" style="width: 30%; height: 3vh" animation="fade"></q-skeleton>
        <div v-else class="text-h5 text-center">{{ organizerName }}</div>

        <q-skeleton v-if="documents === null" type="text" tag="div" style="width: 70%; height: 3vh" animation="fade"></q-skeleton>
        <div v-else class="text-h6 text-center">{{ $t('live.documents.title') }}</div>
        </div>
      </q-img>
    </q-card>


    <div class="q-pa-md-md q-pa-sm q-pb-xl ios-mobile">

      <!-- documents link -->
      <div class="full-width row wrap justify-between q-mb-md bg-grey-4 q-pa-xs" style="border-radius: 20px">
        <q-btn rounded no-caps color="primary" icon="fa-solid fa-caret-left" size="sm" :label="$t('live.documents.back')" :to="{name: 'LiveEvent', params: {event_id: $route.params.event_id}}" />
      </div>
      <!-- end document link -->

      <div class="full-width row items-center content-center">

        <q-markup-table flat class="col-12" v-if="documents === null">
          <thead>
          <tr>
            <th class="text-left" style="width: 150px">
              <q-skeleton animation="blink" type="text" />
            </th>
            <th class="text-right">
              <q-skeleton animation="blink" type="text" />
            </th>
            <th class="text-right">
              <q-skeleton animation="blink" type="text" />
            </th>
            <th class="text-right">
              <q-skeleton animation="blink" type="text" />
            </th>
            <th class="text-right">
              <q-skeleton animation="blink" type="text" />
            </th>
            <th class="text-right">
              <q-skeleton animation="blink" type="text" />
            </th>
          </tr>
          </thead>

          <tbody>
          <tr v-for="n in 5" :key="n">
            <td class="text-left">
              <q-skeleton animation="blink" type="text" width="85px" />
            </td>
            <td class="text-right">
              <q-skeleton animation="blink" type="text" width="50px" />
            </td>
            <td class="text-right">
              <q-skeleton animation="blink" type="text" width="35px" />
            </td>
            <td class="text-right">
              <q-skeleton animation="blink" type="text" width="65px" />
            </td>
            <td class="text-right">
              <q-skeleton animation="blink" type="text" width="25px" />
            </td>
            <td class="text-right">
              <q-skeleton animation="blink" type="text" width="85px" />
            </td>
          </tr>
          </tbody>
        </q-markup-table>

        <q-list class="col-12" v-if="documents">

          <q-item style="background-color: var(--q-primary); border-top-left-radius: 10px; border-top-right-radius: 10px">
            <q-item-section>
              <q-item-label>
                <span class="text-white">{{ $t('live.event.documents') }}</span>
              </q-item-label>
            </q-item-section>
          </q-item>

          <q-item v-ripple v-if="showHorseCtrl === true">
            <q-item-section avatar>
              <q-icon name="fa-light fa-file-pdf" size="sm"></q-icon>
            </q-item-section>

            <q-item-section>
              <q-item-label>
                <span>Chevaux au contrôle</span>
              </q-item-label>
            </q-item-section>

            <q-item-section side>
              <div class="text-grey-8 q-gutter-xs">
                <q-btn
                  size="12px"
                  class="lt-sm"
                  flat
                  dense
                  unelevated
                  color="primary"
                  :to="{name: 'LiveDocumentsHorseCtrl', params: {event_id: $route.params.event_id}}"
                  icon="fa-light fa-file-arrow-down"
                />

                <q-btn
                  size="12px"
                  class="gt-xs"
                  rounded
                  unelevated
                  color="primary"
                  icon="fa-light fa-file-arrow-down"
                  :to="{name: 'LiveDocumentsHorseCtrl', params: {event_id: $route.params.event_id}}"
                  :label="$t('live.documents.consult')"
                ></q-btn>
              </div>
            </q-item-section>
          </q-item>

          <div v-for="(document, indexDocument) in documents.documents" :key='document'>
            <q-item v-ripple :class="indexDocument%2 === 0 && 'line-even'">
              <q-item-section avatar>
                <q-icon :name="`fa-light fa-`+document.type" size="sm"></q-icon>
              </q-item-section>

              <q-item-section>
                <q-item-label>
                  <span>{{ document.name }}</span>
                </q-item-label>
              </q-item-section>

              <q-item-section side>
                <div class="text-grey-8 q-gutter-xs">
                  <q-btn
                    size="12px"
                    class="lt-sm"
                    flat
                    dense
                    unelevated
                    color="primary"
                    @click="downloadFile(document.id)"
                    icon="fa-light fa-file-arrow-down"
                  />

                  <q-btn
                    size="12px"
                    class="gt-xs"
                    rounded
                    unelevated
                    color="primary"
                    icon="fa-light fa-file-arrow-down"
                    @click="downloadFile(document.id)"
                    :label="$t('live.documents.consult')"
                  ></q-btn>
                </div>
              </q-item-section>
            </q-item>

          </div>

          <q-item v-if="documents && Object.keys(documents.documents).length === 0 && showHorseCtrl === false" class="line-even">
            <q-item-section class="fit column wrap text-center justify-center items-center content-center">
            <q-icon name="fa-light fa-file-alt" class="q-mt-lg" size="xl"></q-icon><br />
              {{ $t('live.documents.no-result') }}
            </q-item-section>
          </q-item>

        </q-list>


      </div>

    </div>
  </q-page>
</template>

<script>
import {
  parsed,
} from '@quasar/quasar-ui-qcalendar'
import { defineComponent, ref } from 'vue';
import {openURL, useMeta} from "quasar";
import {useStore} from "vuex";

export default defineComponent({
  name: 'LiveDocuments',
  components: {
  },
  data () {
    return {
      title: ref(this.$i18n.t('system.loading')),
      meta_description: '',
    }
  },
  preFetch ({ store, currentRoute, previousRoute, redirect, ssrContext, urlPath, publicPath }) {
    // fetch data, validate route and optionally redirect to some other route...
    // load document
    return store.dispatch("event/getDocuments", {id: currentRoute.params.event_id})

    // ssrContext is available only server-side in SSR mode
  },
  computed: {
    eventName() {
      if (this.documents) {
        return this.documents.name
      }
      else
        return null
    },
    organizerName() {
      if (this.documents) {
        return this.documents.organizer.name
      }
      else
        return null
    },
    eventType() {
      if (this.documents) {
        return this.documents.type
      }
      else
        return null
    },
    showHorseCtrl() {
      if (this.documents) {
        return this.documents.federation === 'ffe-compet';
      }
      else
        return false
    },
    eventTypeLabel() {

      if (!this.documents)
        return null

      switch (this.documents.type) {
        case 'cce':
          return this.$i18n.t('events.type.cce')
        case 'cso':
          return this.$i18n.t('events.type.cso')
        case 'dressage':
          return this.$i18n.t('events.type.dressage')
        case 'hunter':
          return this.$i18n.t('events.type.hunter')
        case 'derby_cross':
          return this.$i18n.t('events.type.derby_cross')
        case 'derby_eventing':
          return this.$i18n.t('events.type.derby_eventing')
        case 'crossindoor':
          return this.$i18n.t('events.type.crossindoor')
        default:
          return this.documents.type
      }
    },
    configTemplate_mainBackground() {
      if (this.configTemplate !== null && this.configTemplate.main_color) {
        return 'hero-results-compressed-tpl-' + this.configTemplate.main_color + '.jpg'
      }

      return 'hero-results-compressed.jpg'
    }
  },
  methods: {
    formatDate(dateInput) {
      const dateValue = parsed(dateInput + ' 00:00')
      return dateValue.day.toString().padStart(2, '0') + '/' + dateValue.month.toString().padStart(2, '0')  + '/' + dateValue.year.toString()
    },
    downloadFile(id) {
      // https://api.dev.horses-and-competitions.com/fr/gestion/concours/1258/documents/4cb1467c9d7c1d3834ac494b13357099/download
      openURL(process.env.VUE_APP_BACKEND_URL + "fr/gestion/concours/" + this.$route.params.event_id + "/documents/" + id.toString() + "/download?view=1")
    },
  },
  setup () {

    const $store = useStore()
    const documents = $store.getters["event/documentsGetter"]

    const configTemplate = $store.getters["organizer/organizerTemplateGetter"]
    const customDomain = (configTemplate !== null)

    return {
      configTemplate,
      customDomain,
      documents,
    }
  },
  created: function () {

    this.title = this.documents.name
    this.meta_description = this.$i18n.t('live.documents.meta_description') + this.$i18n.t('live.documents.organizedby') + ' ' + this.documents.organizer.name

    useMeta(() => {
      return {
        // whenever "title" from above changes, your meta will automatically update
        title: this.title,
        meta: {
          title: { content: this.title },
          ogTitle: { content: this.title },
          ogUrl: { content: this.$router.currentRoute._value.href },
          twitterUrl: { content: this.$router.currentRoute._value.href },
          twitterTitle: { content: this.title },
          ogDescription: { content: this.meta_description },
          twitterDescription: { content: this.meta_description },
          description: { name:'description', content: this.meta_description },
        }
      }
    })

  },
})
</script>

<style scoped>
.table-challenge  ::v-deep(tr):nth-child(even) {
  background-color: #f3f3f4;
}
.table-challenge ::v-deep(tr):nth-child(odd) {
  background-color: #fdfdfd;
}

.table-challenge ::v-deep(td) {
  border-color: transparent;
  height: 30px;
}

.hero .text-h5, .hero .text-h6 {
  color: #272727;
  font-weight: initial;
}

.hero {
  background: none;
}
</style>


